import { Injectable } from '@angular/core';

interface Sound {
  key: string;
  asset: string;
  isNative: boolean
}0
@Injectable({
  providedIn: 'root'
})
export class AudioService {

  private sounds: Sound[] = [];
  private audioPlayer: HTMLAudioElement = new Audio();
  private forceWebAudio: boolean = true;

  constructor(){

  }

  preload(key: string, asset: string): void {



      let audio = new Audio();
      audio.src = asset;

      this.sounds.push({
        key: key,
        asset: asset,
        isNative: false
      });

    

  }

  play(key: string): void {

    let soundToPlay = this.sounds.find((sound) => {
      return sound.key === key;
    });
    this.audioPlayer.src = soundToPlay.asset;
    this.audioPlayer.play();
    

  }
  stop(){
    this.audioPlayer.pause();
  }
  checkIfAudioEnded(): Boolean {
    return this.audioPlayer.ended
  }

  scheduleAudioStop(delay: number): void {
    setTimeout(() => {
        this.stop();
    }, delay);
}
}